import React from 'react';

const BannerBlog = ({ Title, Description, LinkImage }) => (
    <div className="banner-blog">
        
        <div className="text-blog-introduction">
            <h1> {Title} </h1>
            <p> {Description} </p>
        </div>

        <div className="imagen-blog">
            <img src={LinkImage} alt={Title} />
        </div>

    </div>
)

export default BannerBlog;